export default __webpack_public_path__ + "static/gist-dcbe75585eb67532ede571abdec0954f.png";